import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import firebase from "firebase";
import {
  Button,
  Modal,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from "react-bootstrap";
function FieldGroup({ id, label, help, ...props }) {
  return (
    <FormGroup controlId={id}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  );
}

class RSenha extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      isOpen: false,
      email: "",
      load: ""
    };
  }
  componentWillMount() {
    var config = {
      apiKey: "AIzaSyByyhlriK2-7mtXbEqg-x97c42zWVfJMiE",
      authDomain: "tourbrazil-41fbe.firebaseapp.com",
      databaseURL: "https://tourbrazil-41fbe.firebaseio.com",
      projectId: "tourbrazil-41fbe",
      storageBucket: "tourbrazil-41fbe.appspot.com",
      messagingSenderId: "927605208400"
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
  }

  handleClose() {
    console.log("fecha");
    this.setState({ show: false });
  }

  handleShow() {
    console.log("aberto");
    this.setState({ show: true });
  }
  rSenha() {
    var auth = firebase.auth();
    var emailAddress = this.state.email;

    auth
      .sendPasswordResetEmail(emailAddress)
      .then(() => {
        console.log("1");
        this.setState({
          load: "Um email de recupeção foi enviado para sua caixa de email."
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          load:
            error.code === "auth/user-not-found"
              ? "Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído."
              : "Algo deu errado"
        });
      });
  }
  render() {
    return (
      <div className={css(styles.container)}>
        <a onClick={this.handleShow} className={css(styles.btn)}>
          Esqueci minha senha
        </a>
        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Recuperar Senha</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <span>
                Confirme seu email para que possamos enviar um link de
                recupeção.
              </span>
              <FieldGroup
                id="Email"
                label="Email"
                type="email"
                placeholder="Email"
                onChange={e => this.setState({ email: e.target.value })}
                value={this.state.email}
              />
              {this.state.load}
              <Button
                className="btn btn-primary btn-block"
                type="submit"
                bsStyle="success"
                onClick={() => this.rSenha()}
              >
                Enviar
              </Button>

              {this.props.cadastroState}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-default btn-block"
              onClick={this.handleClose}
            >
              Cancelar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  btn: {
    cursor: "pointer"
  },
  container: {
    paddingTop: "10px",
    textAlign: "center"
  }
});

export default RSenha;



// WEBPACK FOOTER //
// ./src/assets/modalRecuperarSenha/index.js